module.exports = __webpack_public_path__ + "static/symbolic_image-18014f6ff7fef1e36f1e6eaf0064302d.svg";